import React from 'react';
import statusCategoryModel from './model/statusCategoryModel';
import { SelectBasePrototype } from 'clad';

export const SelectStatusCategory = React.forwardRef((props, ref) => {
    const { data, value, onChange, mode, placeholder, labelInValue } = props;
    const handleFetch = ({ query, id, pagination }) =>
        statusCategoryModel.list({ query, id, pagination });

    return (
        <SelectBasePrototype
            mode={mode}
            placeholder={placeholder || _('Select a status')}
            schema={{ idOption: 'id', option: 'name' }}
            fetch={handleFetch}
            onChange={onChange}
            value={value}
            data={data}
            labelInValue={labelInValue || false}
        />
    );
});
